module.exports = __webpack_public_path__ + "img/h5img31.3126a955.png";